
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/about-sustainability",
      function () {
        return require("private-next-pages/[locale]/about-sustainability/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/about-sustainability"])
      });
    }
  